import { apiPath } from '../../constants';
import { axios, apiRequestOptions, transformHttpResponse } from 'utils';

/**
 * PASSWORD RECOVERY — the two anonymous calls.
 *
 * `withoutAuth`, like the login call beside them: somebody who has forgotten
 * their password has no JWT to send, and attaching a stale one would make
 * these fail for exactly the users who need them.
 *
 * Neither dispatches into the store. There is no session yet and nothing else
 * reads the result — the two pages own their own state, which is what keeps a
 * failed reset from leaving anything behind in a Redux slice.
 */

/**
 * Ask for a link. Resolves the same way whatever the address is — the backend
 * answers 202 for an unknown address exactly as for a real one, so that a
 * caller cannot learn who has an account here.
 */
export const requestPasswordReset = email =>
    () => axios(apiRequestOptions(
        apiPath.USER.PASSWORD_RESET_REQUEST,
        { email },
        { withoutAuth: true },
    ))
        .then(transformHttpResponse)
        .then(response => response.data);

/**
 * Spend a link and set the password.
 *
 * REJECTS with the server's body, because here the differences matter: the
 * page has to tell «this link has expired» from «your passwords do not
 * match», and only the server knows which.
 */
export const resetPassword = (token, password, passwordConfirmation) =>
    () => axios(apiRequestOptions(
        apiPath.USER.PASSWORD_RESET,
        { token, password, passwordConfirmation },
        { withoutAuth: true },
    ))
        .then(transformHttpResponse)
        .then(response => response.data)
        .catch(error => {
            throw (error && error.response && error.response.data) || error;
        });
